import { Button, TextInput } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { HiAdjustments, HiSearch, HiX } from "react-icons/hi";
import { USAGE_DROP_FILTER_KEYS } from "./DashboardUsageDropPage.utils";

export const DashboardUsageDropPageFilters = ({
  selectedFilter,
  setSelectedFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-row justify-end p-4">
      <div className="flex w-full flex-1 flex-row gap-2.5">
        {Object.values(USAGE_DROP_FILTER_KEYS).map((filterKey) => (
          <Button
            key={filterKey}
            color="gray"
            onClick={() => setSelectedFilter(filterKey)}
            className={selectedFilter === filterKey ? "bg-gray-100" : ""}
          >
            {t(`pages.dashboardUsageDrop.filters.${filterKey}`)}

            {selectedFilter === filterKey && <HiX className="ml-2 h-5 w-5" />}
          </Button>
        ))}
      </div>

      <TextInput
        className="mr-2"
        type="text"
        icon={HiSearch}
        placeholder="Search"
      />
      <Button color="gray">
        <HiAdjustments className="mr-2 h-5 w-5" /> Last Month
      </Button>
    </div>
  );
};
